export default __webpack_public_path__ + "static/media/pin_Global Stewards_colour.ee0c6594.png";